function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './elements';
/**
 * A RadioGroup component groups radio buttons.
 *
 */

var RadioGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(RadioGroup, _PureComponent);

  var _super = _createSuper(RadioGroup);

  /** Internal state. */
  function RadioGroup() {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var onChange = _this.props.onChange;

      _this.setState({
        selectedValue: value
      }, function () {
        onChange && onChange(value);
      });
    });

    _this.state = {
      selectedValue: null
    };
    return _this;
  }
  /**
   * Handles mounting in component's lifecycle.
   */


  _createClass(RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var selectedValue = this.props.selectedValue;
      /* eslint-disable react/no-did-mount-set-state */

      if (selectedValue !== null) {
        this.setState({
          selectedValue: selectedValue
        });
      }
    }
    /**
     * Handles update in component's lifecycle.
     *
     * @param {Object} prevProps - The component's previous props.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedValue = this.props.selectedValue;

      if (selectedValue !== prevProps.selectedValue) {
        /* eslint-disable react/no-did-update-set-state */
        this.setState({
          selectedValue: selectedValue
        });
      }
    }
  }, {
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this2 = this;

      var selectedValue = this.state.selectedValue;
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          groupName = _this$props.groupName,
          isRow = _this$props.isRow;
      var radios = React.Children.map(children, function (radio) {
        return React.cloneElement(radio, {
          onChange: _this2.handleChange,
          selectedValue: selectedValue,
          name: groupName
        });
      });
      return /*#__PURE__*/React.createElement(Wrapper, {
        isRow: isRow,
        className: className
      }, radios);
    }
  }]);

  return RadioGroup;
}(PureComponent);

var bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    string = PropTypes.string;
/** Prop types. */

RadioGroup.propTypes = {
  /** Radio buttons elements */
  children: node,

  /** className needed by styled-components */
  className: string,

  /** Name the groupe of radio button */
  groupName: string,

  /** Change the radio buttons direction */
  isRow: bool,

  /** Callback triggered on a radio button click  */
  onChange: func,

  /** Value which pre-select the radio button */
  selectedValue: node
};
/** Default props. */

RadioGroup.defaultProps = {
  children: null,
  className: '',
  groupName: null,
  isRow: false,
  onChange: null,
  selectedValue: null
};
export default RadioGroup;